import * as React from "react";
import type { SVGProps } from "react";
const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3323 26.6541H35.6657V21.3458H12.3323V26.6541ZM23.999 47.8076C20.6969 47.8076 17.5987 47.183 14.7042 45.9339C11.8093 44.6848 9.29121 42.9898 7.14999 40.849C5.00916 38.7077 3.31418 36.1897 2.06507 33.2948C0.815962 30.4003 0.191406 27.302 0.191406 24C0.191406 20.6979 0.815962 17.5996 2.06507 14.7051C3.31418 11.8102 5.00916 9.29219 7.14999 7.15097C9.29121 5.01013 11.8093 3.31516 14.7042 2.06605C17.5987 0.816938 20.6969 0.192383 23.999 0.192383C27.301 0.192383 30.3993 0.816938 33.2938 2.06605C36.1887 3.31516 38.7068 5.01013 40.848 7.15097C42.9888 9.29219 44.6838 11.8102 45.9329 14.7051C47.182 17.5996 47.8066 20.6979 47.8066 24C47.8066 27.302 47.182 30.4003 45.9329 33.2948C44.6838 36.1897 42.9888 38.7077 40.848 40.849C38.7068 42.9898 36.1887 44.6848 33.2938 45.9339C30.3993 47.183 27.301 47.8076 23.999 47.8076ZM23.999 42.4992C29.1728 42.4992 33.5495 40.7096 37.1292 37.1302C40.7086 33.5505 42.4982 29.1737 42.4982 24C42.4982 18.8262 40.7086 14.4494 37.1292 10.8697C33.5495 7.29038 29.1728 5.50072 23.999 5.50072C18.8252 5.50072 14.4485 7.29038 10.8687 10.8697C7.28941 14.4494 5.49974 18.8262 5.49974 24C5.49974 29.1737 7.28941 33.5505 10.8687 37.1302C14.4485 40.7096 18.8252 42.4992 23.999 42.4992Z"
      fill="#050033"
    />
  </svg>
);
export default SvgError;
